"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5506],{

/***/ 15506:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(72491);
/* harmony import */ var _modules_core_components_TopLevelContainer__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(74270);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41414);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99084);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(20158);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _ui_Banner_CarouselHero_CarouselHero__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(66286);







// Reduce initial theHTML size, by rendering the bottom half of the page client side.
var BottomSection = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(2018), __webpack_require__.e(1137), __webpack_require__.e(2732)]).then(__webpack_require__.bind(__webpack_require__, 52732)).then(function(m) {
        return m.default;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(52732)
            ];
        }
    },
    ssr: false
});
var TKHomePage = function(param) {
    var bannerData = param.bannerData;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react__WEBPACK_IMPORTED_MODULE_2__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_3___default()), {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                    rel: "canonical",
                    href: "".concat("https://www.theknot.com").concat("/paper")
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_modules_core_components_TopLevelContainer__WEBPACK_IMPORTED_MODULE_4__/* .TopLevelContainer */ .j, {
                children: [
                    bannerData && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ui_Banner_CarouselHero_CarouselHero__WEBPACK_IMPORTED_MODULE_5__/* .CarouselHero */ .H, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, bannerData)),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(BottomSection, {})
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (TKHomePage);


/***/ })

}]);